var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('gantt',{attrs:{"styleConfig":_vm.styleConfig,"dataConfig":_vm.dataConfig,"eventConfig":_vm.eventConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }